const GA_MEASUREMENT_ID = "G-V6M3YFX88Z";

let currentUserEmail = null;

function getGtag() {
  return typeof window !== "undefined" && window.gtag ? window.gtag : null;
}

/**
 * Identify a user after login/session restore.
 * Sets GA4 user_id and custom user properties, and stores the email
 * so every subsequent event is automatically tagged with user_email.
 */
export function identifyUser(user) {
  const gtag = getGtag();
  if (!gtag || !user?.email) return;

  currentUserEmail = user.email;

  gtag("config", GA_MEASUREMENT_ID, { user_id: user.email });
  gtag("set", "user_properties", {
    email: user.email,
    first_name: user.firstName || "",
    last_name: user.lastName || "",
  });
}

/**
 * Clear user identity on sign-out.
 */
export function resetUser() {
  const gtag = getGtag();
  currentUserEmail = null;
  if (!gtag) return;

  gtag("config", GA_MEASUREMENT_ID, { user_id: undefined });
  gtag("set", "user_properties", {
    email: undefined,
    first_name: undefined,
    last_name: undefined,
  });
}

/**
 * Track a virtual pageview for SPA route changes.
 */
export function trackPage(path, title) {
  const gtag = getGtag();
  if (!gtag) return;

  gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    user_email: currentUserEmail || undefined,
  });
}

/**
 * Track a custom event. user_email is automatically attached
 * when a user has been identified.
 * @param {string} eventName - GA4 event name (snake_case recommended)
 * @param {Object} [params] - Event parameters
 */
export function trackEvent(eventName, params = {}) {
  const gtag = getGtag();
  if (!gtag) return;

  gtag("event", eventName, {
    user_email: currentUserEmail || undefined,
    ...params,
  });
}

/**
 * Convenience: track a feature interaction.
 * All feature events are sent under a unified "feature_used" event
 * AND as a specific named event for easier GA4 exploration.
 */
// commented out because we don't currentlyuse it
// export function trackFeature(featureName, action, extraParams = {}) {
//   const params = {
//     feature_name: featureName,
//     feature_action: action,
//     ...extraParams,
//   };

//   trackEvent("feature_used", params);
//   trackEvent(`${featureName}_${action}`, extraParams);
// }
